var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"responsive-image",attrs:{"srcset":_vm.srcset,"sizes":_vm.sizes,"src":_vm.image.url,"alt":_vm.alt || _vm.image.alt || '',"width":_vm.image.dimensions.width,"height":_vm.image.dimensions.height}})}
var staticRenderFns = []

export { render, staticRenderFns }